import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const router = new VueRouter({
  base: window.location.pathname,
  mode: 'history',
});

//Export router so it's available to be used in the store
export { router };